import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import VueScrollactive from 'vue-scrollactive';
Vue.use(VueScrollactive);

// import VueAwesomeSwiper from 'vue-awesome-swiper'
// Vue.use(VueAwesomeSwiper);
import Swiper from '@/utils/swiper/swiper.min.js'; // 注意引入的是Swiper
import '@/utils/swiper/swiper.min.css' // 注意这里的引入

import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
Vue.use(VideoPlayer)

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  //完全显示的时候加载
  preLoad: 1,
  //失败时显示的图片
  error: require('./assets/img/error.png'),
  //加载时显示的GIF图
  loading: require('./assets/img/loading.gif'),
  //尝试加载几次
  attempt: 1
});

Vue.config.productionTip = false

//设置超时时间
axios.defaults.timeout = 5000
//设置api地址
//全局定义axios
// axios.defaults.baseURL = 'http://localhost:48080/admin-api/system/'
axios.defaults.baseURL = 'http://121.41.64.61:48080/admin-api/system/'
Vue.prototype.$http = axios

Vue.prototype.imgserver = 'http://47.120.31.91:9000'



new Vue({
  router,
  Swiper,
  render: h => h(App)
}).$mount('#app')